import React  from 'react';
import Background from './back.jpg';
import Home from './Home/Home';
//import Teaching from './Teaching/Teaching';
import Research from './Research/Research';
import Contact from './Contact/Contact';
import Aztec from './Aztec/Course';
import Papers from './Papers/Papers';
//import Personal from './Personal/Personal';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
//import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import {
  HashRouter,
  Route,
  Switch,
  Link as RouterLink
} from "react-router-dom";

const styleFirstPage =
  {
    flexGrow: 1,
     backgroundImage: "url("+Background+")",
    minHeight:'100vh',
    minWdith:'100vw',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: '#6a737b',
    fontSize: '13p',
    fontFamily: 'Arial',
};

const styleOtherPages =
  {
    flexGrow: 1,
    backgroundColor: '#E6EBE9',
    alignItems: 'center',
    color: '#6a737b'
  };


  const AppbarStyleFirst = {
    background: 'transparent', 
    color: 'white',
    position: 'fixed',
    top: 0,
    elevation: '10'
}

const AppbarStyleOther = {
  background:  '#009688',
  color: 'white',
  align: 'left',
  position: 'fixed',
  top: 0,
  elevation: '10',
}







function App() {
  const routes = ["/", "/research","/papers","/contact","/Aztec"];


  return (
    
   <div>
       <HashRouter>

       <Route
       path="/"
       render={(history) => (
         <div  style={ (history.location.pathname  === routes[0])?  styleFirstPage  :  styleOtherPages}>
         <AppBar style={ (history.location.pathname  === routes[0]) ?  AppbarStyleFirst  :  AppbarStyleOther}
        >
           <Tabs 
           value={
             history.location.pathname !== "/"
               ? history.location.pathname
               : false
           }   
           centered       
           indicatorColor="primary"
           textColor="inherit"
           backgroundColor="secondary"   
           >      
            <Tab
                   label="Home"
                   value={routes[0]}
                   component={RouterLink}
                   to={routes[0]}
                 />     
           <Tab
                   label="Research"
                   value={routes[1]}
                   component={RouterLink}
                   to={routes[1]}
                 />
                 <Tab
                   label="Papers"
                   value={routes[2]}
                   component={RouterLink}
                   to={routes[2]}
                 />
                  <Tab
                   label="CV"
                   value={routes[3]}
                   component={RouterLink}
                   to={routes[3]}
                 />
                   <Tab
                   label="Aztec"
                   value={routes[4]}
                   component={RouterLink}
                   to={routes[4]}
                 />
         </Tabs>
         </AppBar>
         <Slide direction="left" in={true} mountOnEnter unmountOnExit >
     <div align="left" component="div"  style={{ width: '90%',  padding: 8 * 3}}>
     <Switch>
           <Route exact path="/" component={Home} />
           <Route path="/research" component={Research} />
           <Route path="/papers" component={Papers} />
           <Route path="/contact" component={Contact} />
            <Route path="/Aztec" component={Aztec} />
    </Switch>
     </div>
     </Slide>
         </div>
         )}
         ></Route>
         
 
         
       </HashRouter>
       </div>
  );
 
}

export default App;
